import React, { useMemo } from "react";
import CheckEmail from "./CheckEmail";

const EmailForm = ({ formik, wValidationCode, enabled, getInputClasses }) => {
  const emailField = formik.getFieldProps("email");
  const isInstitutionAccount = useMemo(
    () => !emailField.value.includes("outlook"),
    [emailField.value]
  );

  return (
    <>
      <input
        placeholder="Email"
        type="email"
        className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
          "email"
        )}`}
        name="email"
        {...formik.getFieldProps("email")}
      />
      {formik.touched.email && formik.errors.email ? (
        <div className="fv-help-block text-center">{formik.errors.email}</div>
      ) : (
        wValidationCode &&
        formik.getFieldProps("email").value !== "" &&
        enabled && <CheckEmail institutionAccount={isInstitutionAccount} />
      )}
    </>
  );
};

export default EmailForm;
